import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

@Component({
    selector: 'ms-greyhound-timer',
    templateUrl: './greyhound-timer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class GreyhoundTimerComponent implements OnChanges {
    @Input() timeInSeconds: number;
    @Input() race: WinGameFixture;
    display = false;
    isRaceOff: boolean;

    constructor(public sitecore: Sitecore) {}
    ngOnChanges() {
        this.isRaceOff = this.race.addons.raceSummary?.toLowerCase() === this.sitecore.horseRacing.raceSummary.RaceOff.toLowerCase();
    }

    onDisplay($event: boolean) {
        this.display = $event;
    }
}
